import { Typography } from '@mui/material';
import { newLineAfterDotEndOfSentence } from 'Utils/newLineAfterDot';

interface IGeneralData {
  generalData: string;
}

export const GeneralData = ({ generalData }: IGeneralData) => {
  return (
    <Typography variant={'body3'} margin='0 0 30px 0'>
      {newLineAfterDotEndOfSentence(generalData)}
    </Typography>
  );
};
